import { Injectable } from '@angular/core';
import { ConfigService } from "./configService";
import { BaseApi } from "./baseService";
import { Http, RequestOptions } from "@angular/http";
import { Observable } from "rxjs";

@Injectable()
export class PublisherService extends BaseApi{

    constructor(http: Http, configService: ConfigService) {
        super(http, configService);
    }

    public bbPublisherRequest(uniqueRequestId: string, data: any): Observable<any> {
        return this.http.post(this.config.BBPublisherUrl + '/' + uniqueRequestId, data);
    }
}



// WEBPACK FOOTER //
// ./app/services/publisher.service.ts